var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a41c5",
    d: "m 14.602454,7.3989464 -4.590001,4.5900006 4.590001,4.6 1.41,-1.42 -3.18,-3.18 3.18,-3.1800006 m 4,-5.82 c 1.11,0 2,0.9 2,2 V 18.988947 a 2,2 0 0 1 -2,2 H 6.0124533 a 2,2 0 0 1 -2,-2 V 4.9889464 a 2,2 0 0 1 2,-2 z",
    id: "path1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect4",
    width: 8.6177607,
    height: 10.50193,
    x: 7.4751697,
    y: 6.5482626
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect5",
    width: 10.656371,
    height: 3.5521235,
    x: 4.1028233,
    y: 9.9768343
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect6",
    width: 4.9111967,
    height: 0.40154439,
    x: 14.826255,
    y: 13.559846
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.52632
    },
    id: "rect7",
    width: 4.0234947,
    height: 14.029706,
    x: 10.976414,
    y: 4.9796362,
    ry: 0.30106664
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.05167
    },
    id: "rect8",
    width: 13.947053,
    height: 3.9769204,
    x: 6.0766988,
    y: 9.9994869,
    ry: 0.33447179
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect1",
    width: 7.1660233,
    height: 4.1389961,
    x: 9.3590736,
    y: 5.0965252
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect2",
    width: 9.2046328,
    height: 6.0231662,
    x: 8,
    y: 3.9536679,
    ry: 0.30106664
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect3",
    width: 5.3745174,
    height: 5.1969113,
    x: 10.725869,
    y: 13.976834
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4a41c5",
      fillOpacity: 1
    },
    id: "rect9",
    width: 4.6958442,
    height: 0.6060915,
    x: 10.521967,
    y: 9.3971491
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.c723cf73179c55c6c624119f3496e802.svg";
export { ForwardRef as ReactComponent };